import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import NextLink from "next/link";
import styles from "./hero-link.module.css";
import { TrackingEventTypes } from "@cinch-nx/shared-analytics";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
export function HeroLink(_param) {
    var link = _param.link, text = _param.text, trackEvent = _param.trackEvent, rest = _object_without_properties(_param, [
        "link",
        "text",
        "trackEvent"
    ]);
    if (!text || !link.url) {
        return null;
    }
    return /*#__PURE__*/ _jsx(NextLink, {
        href: link.url,
        passHref: true,
        children: /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, storyblokEditable(_object_spread_props(_object_spread({}, rest), {
            link: link,
            text: text
        }))), {
            className: styles["promoLink"],
            target: link.linktype === "url" ? "_blank" : undefined,
            href: "#shop-now",
            onClick: function() {
                return trackEvent({
                    eventName: "promo hero link",
                    type: TrackingEventTypes.ADOBE,
                    data: {
                        event: {
                            name: "click",
                            category: "link",
                            label: "Promo link click",
                            action: "Promo Link link click"
                        }
                    }
                });
            },
            children: text
        }))
    });
}
